import { isClient, isSioHost } from '@systemeio/util'
import { HostOnServerInterface } from './get-host-on-server'

export const getWhiteLabelChecks = ({ hostOnServer }: HostOnServerInterface) => {
  const isSio = isClient() ? isSioHost(window.location.host) : isSioHost(hostOnServer)

  return {
    isSio,
    isWhiteLabel: !isSio,
  }
}
